<canvas #barChart ></canvas>
